import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 13325 16942"
    {...props}
  >
    <path
      d="M4964 14920V9723L961 3522c-351-561-598-996-743-1309S0 1629 0 1397c0-378 149-706 443-985C736 138 1099 0 1534 0c454 0 798 130 1034 385 233 256 584 768 1053 1534l3064 4973 3099-4973c183-305 339-560 469-770 126-206 263-401 420-584 152-183 320-325 507-420s413-145 683-145c416 0 764 138 1042 408 282 271 420 588 420 943 0 290-69 584-210 874s-386 690-729 1206L8284 9723v5197c0 679-156 1183-469 1519-313 335-714 503-1195 503-492 0-892-164-1198-496-305-332-458-839-458-1526z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
